import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/warehouse-frontend/src/components/product/ProductDetailClient.tsx");
